const BACKEND_URL = process.env.REACT_APP_API_ENDPOINT_CMO
const API_URL = `${BACKEND_URL}api/api`

export function getBackendUrl() {
  return BACKEND_URL
}

export async function getCmo(url, config = {}) {
  const headers = addHeaders(config)

  try {
    const headers = addHeaders(config)
    const response = await fetch(`${API_URL}/${url}`, {
      ...headers,
      method: "GET",
    })
    const data = await response.json()
    return data
  } catch (error) {
    console.log(error)
    return error
  }
}

export async function postCmo(url, body, config = {}) {
  try {
    const headers =
      url === "login/authenticate"
        ? {
            headers: {
              ...config.headers,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        : addHeaders(config)

    const response = await fetch(`${API_URL}/${url}`, {
      ...headers,
      method: "POST",
      body: JSON.stringify(body),
    })
    const data = await response.json()
    return data
  } catch (error) {
    console.log(error)
    return error
  }
}

function addHeaders(config, contentType = "application/json") {
  let newConfig = {
    ...config,
    headers: {
      ...config.headers,
      "Content-Type": contentType,
      Accept: "application/json",
    },
  }

  let token = localStorage.getItem("authUser")
  if (token != null) {
    token = token.replace('"', "").replace('"', "")
    newConfig = {
      ...newConfig,
      headers: {
        ...newConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    }
  }
  return newConfig
}

function unauthorized() {
  /* localStorage.removeItem("authUser")
  window.location.href = "/" */
}
